'use strict';

var GoToItem = {
  go: function (event) {
    event.preventDefault();
    var url = $(this).data('href') || $(this).find('a').attr('href');
    if (!url) return;

    location.href = url;
  }
};

$('body').on('click tap', '[data-href]', GoToItem.go);
